import { useIsMobile } from "@workspace/ui/hooks/use-mobile";
import { MarketplaceJobDrawer } from "./marketplace-job-drawer";
import { MarketplaceJobPopup } from "./marketplace-job-popup";
import type { MarketplaceJob } from "./use-cluster";

export function MarketplaceJobPopupResponsive({
  job,
  isOpen,
  onActivate,
  onOpenChange,
  isActive,
  isHovered,
}: {
  job: MarketplaceJob;
  isOpen?: boolean;
  onActivate?: () => void;
  onOpenChange?: (open: boolean) => void;
  /** Phase 5: marker highlight when its row is selected/hovered. */
  isActive?: boolean;
  isHovered?: boolean;
}) {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <MarketplaceJobDrawer
        isActive={isActive}
        isHovered={isHovered}
        isOpen={isOpen}
        job={job}
        onActivate={onActivate}
        onOpenChange={onOpenChange}
      />
    );
  }

  return (
    <MarketplaceJobPopup
      isActive={isActive}
      isHovered={isHovered}
      isOpen={isOpen}
      job={job}
      onActivate={onActivate}
      onOpenChange={onOpenChange}
    />
  );
}
